import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";

@Injectable()
export class UEData {
  data: any;
  searchdata: any;
  uetoday: any;
  updateRequired:boolean;
  searchQuery:string;

  constructor(public http: Http
            , public common: CommonData
            , public userData: UserData
            
            ) {
            this.searchQuery = "";       
  
            }
          
  clear(){
    this.searchQuery = "";
    if(this.data!=null){
      this.data.length = 0;
    }
    if(this.searchdata!=null){
      this.searchdata.length = 0;
    }
    this.updateRequired = false;
  }



  load() {
    //console.log('load UE');
    return new Promise(resolve => {
      if(this.userData.loggedin){

        this.http.get(this.common.baseurl+'bussen/getassigned?token='+this.userData.jwt).subscribe(res => {
          this.data = res.json().data;
          this.updateRequired = false;
          
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer ue-data.ts');
          console.log(error);
      });

      }
    });
  }

  search(searchQuery) {
    this.searchQuery = searchQuery;
    return new Promise(resolve => {
      if(this.userData.loggedin){
        this.http.get(this.common.baseurl+'bussen/search?searchQuery='+searchQuery+'&token='+this.userData.jwt).subscribe(res => {
          this.searchdata = res.json().data;
          this.updateRequired = false;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer search ue-data.ts');
          console.log(error);
      });

      }
    });
  }

  getUEToday(){
    return new Promise(resolve => {
      if(this.userData.loggedin){
        //console.log("getUEToday");
        this.http.get(this.common.baseurl+'bussen/gettoday?token='+this.userData.jwt).subscribe(res => {
          this.uetoday = res.json().data;
          this.updateRequired = false;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer search ue-data.ts');
          console.log(error);
      });

      }
    });
  }  

  async getMandatByURLIdent(urlident: string): Promise<number> {

    var data = JSON.stringify({
      urlident: urlident,
      token: this.userData.jwt
    });
    //    let i = await this.ueData.getMandatByURLIdent("");
    const response = await this.http.post(this.common.baseurl+'bussen/getmandatbyurlident',data).toPromise();
    //console.log(response.json());
    if(response.json().data){
      return response.json().data.mandat_id;
    }
    else{
      return -1;
    }
    //return response.json().bpi[currency].rate;
  }  

  async checkUEAssignableToPP(urlident: string, ppid: number): Promise<boolean> {

    var data = JSON.stringify({
      urlident: urlident,
      ppid: ppid,
      token: this.userData.jwt
    });
    //    let i = await this.ueData.checkUEAssignableToPP("");
    const response = await this.http.post(this.common.baseurl+'bussen/checkueassignabletopp',data).toPromise();
    if(response.json().data){
      //console.log(response.json().data);
      return response.json().data;
    }
    else{
      return false;
    }
    //return response.json().bpi[currency].rate;
  }    

  async checkUEScannedAlready(urlident: string): Promise<boolean> {

    var data = JSON.stringify({
      urlident: urlident,
      token: this.userData.jwt
    });
    //    let i = await this.ueData.checkUEAssignableToPP("");
    const response = await this.http.post(this.common.baseurl+'bussen/checkuescannedalready',data).toPromise();
    if(response.json().data){
      if(response.json().data.uescanned===true){
        return true;
      }
      else{
        return false; 
      }
    }
    else{
      return false;
    }
    //return response.json().bpi[currency].rate;
  }    
  async overrideUE(urlident: string): Promise<boolean> {

    var data = JSON.stringify({
      urlident: urlident,
      token: this.userData.jwt
    });
    //    let i = await this.ueData.checkUEAssignableToPP("");
    const response = await this.http.post(this.common.baseurl+'bussen/overrideue',data).toPromise();
    if(response.json().data){
      if(response.json().data.override===true){
        return true;
      }
      else{
        return false; 
      }
    }
    else{
      return false;
    }
    //return response.json().bpi[currency].rate;
  }  
  

  getUE() {
    return this.load().then(data => {
      //console.log("getParkplaetze"+ data);
      return data;
    });
  }


  update(ue){
    return new Promise(resolve => {
      var data = JSON.stringify({
            ue: ue,
            ue_id:ue.busid,
            token: this.userData.jwt
        });

      this.http.post(this.common.baseurl+'bussen/updatenew',data)
        .subscribe(data => {
          let response = data.json();
          this.updateRequired = true;
          if(response.success === true){
          }
          else{
            /*
            let toast = this.toastCtrl.create({
              message: 'Login nicht erfolgreich',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();     
            */       
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, ue-update no answer');
          console.log(error);
      });
    });
  }


  sotrno(ue , reason){
    return new Promise(resolve => {
      var data = JSON.stringify({
            ue: ue,
            reason: reason,
            token: this.userData.jwt
        });
    
      this.http.post(this.common.baseurl+'bussen/storno',data)
        .subscribe(data => {
          let response = data.json();
          this.updateRequired = true;
          if(response.success === true){
          }
          else{
            /*
            let toast = this.toastCtrl.create({
              message: 'Login nicht erfolgreich',
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            toast.present();     
            */       
          }
        resolve([this.data]);          
        }, error => {
          console.log('HTTP Error, ue-storno no answer');
          console.log(error);
      });
    });
  }


}



// WEBPACK FOOTER //
// ./src/providers/ue-data.ts